import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './Components/header/Header';
const root = ReactDOM.createRoot(document.getElementById('root'));

function getCurrentPath(){
  const path = window.location.href;
  return path.substring(path.lastIndexOf("/") + 1);
}


const route=   getCurrentPath();
const theme = "dark";

root.render(
  <>
  <Header route={route} theme={theme}/>
  <App route={route}  />
  </>
);

reportWebVitals();
